import {createSelector} from 'reselect';

const getUser = state => state.user;

export const selecetusertype = createSelector([getUser], user => user);
